




















































import Vue from 'vue';
import TableProvider from '@/api/TableProvider';
import { EffectOutputType } from '@/models/skills/raw/IStateEffectTableRow';
import { blowDisplayName } from '@/models/skills/blows/registry';
import type { IStateEffectTableRow } from '@vincentzhang96/dv-dnt-table-interfaces/src/duck';
import { FileTableResolvedTableRow } from '@vincentzhang96/dv-dnt-table-interfaces';

type StateEffectTableRow = FileTableResolvedTableRow<IStateEffectTableRow, '_EffectSkinFileName'|'_EffectAniFileName'|'_EffectActFileName'>;

interface IData {
    loading: boolean;
    effect: StateEffectTableRow|null;
    error: string;
}

export default Vue.extend({
    props: {
        stateEffectId: {
            type: Number as () => number,
        },
        nested: {
            type: Boolean as () => boolean,
            default: false,
        },
    },
    watch: {
        stateEffectId() {
            this.load();
        }
    },
    data(): IData {
        return {
            loading: false,
            effect: null,
            error: '',
        };
    },
    computed: {
        effectOutputType(): string {
            if (this.effect) {
                return EffectOutputType[this.effect._EffectOutputType];
            }

            return '';
        },
        boundBlowName(): string {
            if (this.effect) {
                return blowDisplayName(this.effect._StateEffectIndex);
            }

            return '';
        },
        cardName(): string {
            if (!this.effect) {
                return `State VFX #${this.stateEffectId}`;
            }
            if (this.effect._StaticName) {
                return this.effect._StaticName;
            }
            if (this.effect._StateEffectIndex) {
                return blowDisplayName(this.effect._StateEffectIndex);
            }
            return `State VFX #${this.stateEffectId}`;
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            try {
                this.loading = true;
                this.error = '';
                this.effect = await TableProvider.getTableRow<StateEffectTableRow>('stateeffecttable', this.stateEffectId, undefined, {
                    fileresolve: ['_EffectSkinFileName', '_EffectAniFileName', '_EffectActFileName'],
                });
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.error = String(error);
            }
        }
    }
})
